import styled from 'styled-components';
import { Accordion, AccordionSummary, Typography } from '@mui/material';

import colors from '../../styles/colors';

const StyledAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  background-color: ${colors.shades.gamma4};
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 5px;
  margin-bottom: 15px;
  box-shadow: none;
  :before {
    display: none;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  & .MuiAccordionSummary-expandIconWrapper {
    ${({ $preventrotation }) => ($preventrotation && 'transform: none;')}
  }

  & .MuiAccordionSummary-content {
    display: flex;
    column-gap: 10px;
    align-items: center;
    justify-content: space-between;
  }
`;

const Title = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  line-height: 14px;
  text-transform: uppercase;
  color: ${colors.shades.beta1};
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

export {
  StyledAccordion,
  StyledAccordionSummary,
  Title,
  TitleContainer,
};
